
export default {
  name: 'HeroLayer'
}
